<template>
  <div id="admin-exam-read-student">
    <!-- 待阅卷的学生列表 -->
    <diy_table
      :loading="loading"
      :buttonList="buttonList"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      @handleClickTop="handleClickTop"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as examData from "./js/exam.js";
export default {
  data() {
    return {
      uaseData: {},
      loading: false,
      examId: "",
      buttonList: examData.getTopButArray("read_student"),
      tableMenu: examData.getQuestionStudentTableMenu(),
      tableData: [],
      tableButton: examData.getTableBUttonList("read"),

      tempUser: {},

      dialogData: {
        flag: false,
        title: "阅卷",
        width: "45%",
        tempData: {},
        dialogData: [{ type: "student-test-paper" }],
        buttonList: [
          { text: "确定", active: "makesure_read_paper" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    /**
     * 初始化表格数据
     */
    async initTable(data) {
      this.loading = true;
      try {
        let requestData = {
          examId: this.examId,
        };
        let resultData = await this.$request({
          url: "/teacherExam/getAllExamUserList",
          method: "post",
          data: requestData,
        });
        setTimeout(() => {
          this.tableData = [];
          resultData.forEach((element) => {
            if (element.grade == null) {
              // 没有分数,即没有阅卷
              element.successNum = "-";
              element.errorNum = "-";
              element.grade = "-";
            } else {
              element.successNum = element.successNum + "/" + element.num;
              element.errorNum = element.errorNum + "/" + element.num;
            }
            if (element.status == "缺考") {
              element.subTime = "-";
              this.$set(element, "rowColor", "#ff3737");
            } else {
              this.$set(element, "rowColor", "#22c02f");
            }
            this.tableData.push(element);
          });
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 搜索框旁边的按钮操作
     */
    handleClickTop(active) {
      switch (active) {
        case "export":
          // 导出学员成绩
          this.$requestForReport(
            "post",
            "/examPlan/exportExamPlan",
            { id: this.examId },
            (data) => {
              let blob = new Blob([data], {
                type: "application/force-download",
              }); // Blob 对象表示一个不可变、原始数据的类文件对象
              console.log(blob);
              let fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
              fileReader.readAsDataURL(blob);
              //开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
              fileReader.onload = (e) => {
                let a = document.createElement("a");
                a.download = `考试成绩.xls`;
                a.href = e.target.result;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              };

              this.$message({
                type: "success",
                message: "导出成功!",
                duration: 1000,
              });
            }
          );
          break;

        default:
          break;
      }
    },
    /**
     * 表格中的操作事件
     */
    async handleClick(data) {
      try {
        this.tempUser = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "read_paper":
            // 阅卷
            if (this.tempUser.status == "缺考") {
              throw { message: "当前学员缺考本次考试,无需阅卷操作!" };
            }
            let requestData = {
              tId: this.examId,
              uId: this.tempUser.userId,
            };
            let resultData = await this.$request({
              url: "/teacherExam/getExamDetailsByUserForRead",
              method: "post",
              data: requestData,
            });
            this.dialogData.title = "学员:" + this.tempUser.userName;
            // 将所有未打分的全部置为0分
            resultData.testPaper.forEach((element) => {
              element.item.forEach((ele) => {
                if (ele.grade == null || ele.grade == "") {
                  ele.grade = 0;
                }
              });
            });
            this.dialogData.dialogData = [
              { type: "student-test-paper", value: resultData.testPaper },
            ];
            this.dialogData.buttonList = [
              { text: "人工评分", active: "makesure_read_paper" },
            ];
            this.dialogData.flag = true;
            break;
          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    async dialogOper(active) {
      try {
        switch (active) {
          case "makesure_read_paper":
            // 确定阅卷
            /**
             * 1.判断所打的分值是否合规
             * 2.拼接接口所需数据
             * 3.调用接口后,重新渲染界面
             */
            let requestData = {
              questionList: [],
              uId: this.tempUser.userId,
              examId: this.examId,
            };
            let resultData = "";
            this.dialogData.dialogData[0].value.forEach((element) => {
              element.item.forEach(async (ele) => {
                if (this.changeGrade(ele.grade, ele.points)) {
                  let dd = {
                    questionId: ele.questionId,
                    grade: ele.grade,
                  };
                  requestData.questionList.push(dd);
                } else {
                  throw "";
                }
              });
            });
            console.log("确认阅卷", requestData);
            resultData = await this.$request({
              url: "/teacherExam/readExam",
              method: "post",
              data: requestData,
            });
            this.dialogData.flag = false;
            this.initTable({});
            break;
          case "cancel":
            // this.colseDialog();
            this.dialogData.flag = false;
            break;

          default:
            break;
        }
      } catch (error) {
        if (error.message) {
          this.$message({
            message: error.message,
            type: "warning",
            duration: 1000,
          });
        }
      }
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
    /**
     * 评分的判断
     * stuGrade : 阅卷老师打得分
     * queGrade : 当前题目的最高分
     * 1.判断当前打得分只能是数字
     * 2.判断当前打得分不能比当前题目的分值高
     */
    changeGrade(stuGrade, queGrade) {
      try {
        if (!this.$baseData.judgeStringIsNumber(stuGrade)) {
          throw "分值只能为数值型!";
        }
        if (stuGrade < 0) {
          throw "分值不能为负数!";
        }
        if (stuGrade > queGrade) {
          throw "最大分值为" + queGrade + "分";
        }
        return true;
      } catch (error) {
        this.$message({
          message: error,
          type: "warning",
          duration: 1000,
        });
        return false;
      }
    },
  },
  async mounted() {
    this.uaseData = JSON.parse(sessionStorage.getItem("userData"));
    this.examId = this.$route.query.id;
    await this.initTable({});
  },
};
</script>

<style lang="less" scoped>
#admin-exam-read-student {
  width: 100%;
  height: 100%;
}
</style>